import { render, staticRenderFns } from "./lastUp.vue?vue&type=template&id=35b2885a&scoped=true&lang=pug"
import script from "./lastUp.vue?vue&type=script&lang=js"
export * from "./lastUp.vue?vue&type=script&lang=js"
import style0 from "./lastUp.vue?vue&type=style&index=0&id=35b2885a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2885a",
  null
  
)

export default component.exports